import queryString from 'query-string';

import { createAxiosInstance } from '~/plugins/axios.plugin';

class FunctiosService {
  constructor() {
    this.client = createAxiosInstance({ baseURL: process.env.PLATAFORMA_API, useAccessToken: true });
  }

  getById(id) {
    return this.client.get(`academic/function/${id}`);
  }

  getAll(sortBy, order, name, page, perPage) {
    const stringified = queryString.stringify(
      { sortBy, order, name, page, perPage },
      { skipNull: true, skipEmptyString: true }
    );

    return this.client.get(`academic/function${stringified && `?${stringified}`}`);
  }

  create({ name, description, roleId, originalRoleId, isActive, isVisibleInstitutionUsersToStudents, isVisibleToStudentSendMessage, externalId, isDefault }) {
    return this.client
      .post('academic/function', {
        name,
        description,
        isVisibleInstitutionUsersToStudents,
        isVisibleToStudentSendMessage,
        externalId,
        roleId,
        originalRoleId,
        isActive,
        isDefault
      });
  }

  edit({ id, name, description, isActive, isVisibleInstitutionUsersToStudents, isVisibleToStudentSendMessage, externalId, isDefault }) {
    return this.client
      .put(`academic/function/${id}`, {
        name,
        description,
        isActive,
        isVisibleInstitutionUsersToStudents,
        isVisibleToStudentSendMessage,
        externalId,
        isDefault
      });
  }

  delete(id) {
    return this.client.delete(`academic/function/${id}`);
  }
}

export default new FunctiosService();
